import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRefer } from '../../context/refer/ReferContext';
import BackgroundImg from '../../assets/Background/agent_portal_hero_bg.png';
import ReferLoadingState from './sections/ReferLoadingState';
import ReferNotFoundState from './sections/ReferNotFoundState';
import ReferProfileCard from './sections/ReferProfileCard';

const ReferPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const agentParam = queryParams.get('agent');

  const { agentDetails, loading, error, fetchPublicProfile } = useRefer();

  useEffect(() => {
    fetchPublicProfile(agentParam);
  }, [agentParam, fetchPublicProfile]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6 text-center font-sans relative"
      style={{
        backgroundImage: `url('${BackgroundImg}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Background overlay and blur */}
      <div className="absolute inset-0 bg-white/60 backdrop-blur-[6px]" />

      {/* Center Modal */}
      <div className="max-w-md w-full bg-white/95 backdrop-blur-xl border-2 border-[#067978]/45 rounded-3xl p-10 shadow-[0_24px_60px_rgba(6,121,120,0.18)] relative overflow-hidden z-10">
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#067978]/5 rounded-full blur-3xl opacity-30 pointer-events-none" />
        <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-teal-500/5 rounded-full blur-3xl opacity-30 pointer-events-none" />

        <div className="relative z-10 flex flex-col items-center">
          {loading ? (
            <ReferLoadingState />
          ) : error ? (
            <ReferNotFoundState agentParam={agentParam} />
          ) : (
            <ReferProfileCard agentDetails={agentDetails} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ReferPage;
